import PrimaryFooter from "@ebsco-new-ui/primary-footer";
import React from "react";
import messages from "./footer-messages";

import "@ebsco-new-ui/primary-footer/style.css";
import "./footer.scss";

const Footer = () => (
  <PrimaryFooter
    shouldRenderManageMyCookies={false}
    sessionType="personal"
    className="pua-footer"
    messages={messages}
  />
);

export default Footer;
